import { render, staticRenderFns } from "./reportForms.vue?vue&type=template&id=45b19984&scoped=true&"
import script from "./reportForms.vue?vue&type=script&lang=js&"
export * from "./reportForms.vue?vue&type=script&lang=js&"
import style0 from "./reportForms.vue?vue&type=style&index=0&id=45b19984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b19984",
  null
  
)

export default component.exports